import styled from 'styled-components'
import { Form } from 'semantic-ui-react'

/**
 * FormInput Styled Components
 *
 * Single Form.Field wrapper that:
 * - Carries Semantic UI's `.field` class so `Form.Group widths='equal'` distributes correctly
 * - Provides position: relative for the absolute-positioned FormFieldError label
 */
export const StyledFormField = styled(Form.Field)`
  position: relative;
  padding: 0.5em 0;

  label {
    display: block;
    padding: 0.3em 0 0.2em 0.2em;
  }

  &.required label {
    position: relative;
    padding-left: 0.75em;

    &::before {
      color: var(--red);
      content: '* ';
      font-size: 1.4em;
      left: 0;
      position: absolute;
      top: 0.2em;
    }
  }

  /* Suppress Semantic UI's auto-asterisk on required labels so we don't
     double up with the custom ::before above. !important is required because
     Semantic UI's '.ui.form .required.field > label::after' selector outranks
     the styled-component class selector on specificity. */
  &.required label::after {
    content: none !important;
  }

  input:focus {
    border-color: var(--primary) !important;
  }

  &.error input,
  input.error {
    border-color: #ca0808 !important;

    &:focus {
      border-color: #ff0000 !important;
    }
  }

  /* Semantic UI Dropdown error styling (for PlaceSelect and FormSelect) */
  &.error .ui.dropdown,
  .ui.dropdown.error {
    border-color: #ca0808 !important;

    &:focus,
    &.active {
      border-color: #ff0000 !important;
    }
  }

  /* Match FormSelect height (40px total) - Override Semantic UI */
  .ui.input > input {
    min-height: 38px !important;
    padding: 0.67857143em 1em !important;
    box-sizing: border-box;
  }

  &.disabled input {
    opacity: 0.9;
    background-image: repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5) 5px,
      rgba(243, 243, 243, 0.5) 5px,
      rgba(243, 243, 243, 0.5) 10px
    );
    color: #666;
  }
`

/**
 * Backwards-compatible alias for PlaceSelect (which imported StyledFieldContainer
 * separately from StyledFormField). Both names now resolve to the same wrapper.
 */
export const StyledFieldContainer = StyledFormField
